import React from "react";

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  onSearch: () => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  onSearch,
  placeholder = "Search clients...",
}) => {
  return (
    <div className="manual-search-container" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      
      {/* Wrapper to allow absolute positioning of the 'X' button */}
      <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
        <input
          type="text"
          className="manual-search-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} // This triggers the live filter in the parent
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSearch();
            }
          }}
          style={{
            padding: "8px 35px 8px 16px", // Added right padding (35px) to make room for the 'X'
            borderRadius: "4px",
            border: "1px solid #cccccc",
            width: "450px",
            fontSize: "var(--font-size-base)",
            outline: "none",
            transition: "border-color 0.3s ease"
          }}
        />

        {/* Clear Button (X) - Shows only when there is text */}
        {searchTerm && (
          <span 
            onClick={() => setSearchTerm("")} // Clears the input and triggers the table reset
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#999",
              fontSize: "var(--font-size-2xl)",
              fontWeight: "bold",
              userSelect: "none"
            }}
          >
            ×
          </span>
        )}
      </div>
    </div>
  );
};

export default SearchBar;